// @flow
import React, { useCallback, useContext, useMemo } from 'react';
import { DataFetcherContainer } from '@presentational/DataFetcherContainer';
import { useGetStreamingProjectsMetadataQuery } from '@streaming-projects/service-definitions/streamingProjectsApi';

import { RATE_CARD_BACKEND_NAME } from '../constants';

import { EstimateContext } from './EstimateContext';
import { MonthlyInputsMetaDataContext } from './MonthlyInputsMetaDataContext';

export const MonthlyInputsMetaDataContextProvider = ({ children }) => {
  const estimate = useContext(EstimateContext);
  const rateCard = estimate.inputs[RATE_CARD_BACKEND_NAME];

  if (!rateCard) {
    throw new Error('An estimate must have a valid rate card!');
  }

  const tagsToQuery = [
    'CLUSTER_CONFIGS',
    'FLINK_POOL_CONFIGS',
    'TABLEFLOW_CONFIGS',
    'STREAM_GOVERNANCE_CONFIGS',
    `RATE_CARD=${rateCard}`,
  ];
  const query = tagsToQuery.join(',');

  const dataFetchingArgs = useMemo(() => [{ query }], [query]);
  const dataFetchingFunction = useCallback(useGetStreamingProjectsMetadataQuery, []);

  return (
    <DataFetcherContainer
      dataFetchingArgs={dataFetchingArgs}
      dataFetchingFunction={dataFetchingFunction}
    >
      {(data) => (
        <MonthlyInputsMetaDataContext.Provider value={data}>
          {children}
        </MonthlyInputsMetaDataContext.Provider>
      )}
    </DataFetcherContainer>
  );
};
